import * as React from "react";
import { resolve } from "inversify-react";
import Button from "src/core/ui/button";
import Input from "src/core/ui/input";
import PaymentComponent from "src/core/ui/payment-component";
import IdentityService from "src/services/identity.service";
import PaymentService from "src/services/payment.service";

interface Props {
    onProcessing?: () => void;
    onSuccess?: () => void;
    onError?: () => void;
}

interface State {
    credits: string;
    payment: boolean;
}

export default class AddCreditsComponent extends React.Component<Props, State> {
    @resolve
    public identityService: IdentityService;

    @resolve
    public paymentService: PaymentService;

    state: State = {
        credits: "",
        payment: false,
    };

    handleCreditsChange(credits: string): void {
        this.setState({ credits });
    }

    showPayment(): void {
        this.paymentService.reset();
        this.setState({ payment: true });
    }

    goBack(): void {
        this.setState({ payment: false });
    }

    onCompleted(): void {
        this.identityService.refreshUserInfo();
        if (this.props.onSuccess) this.props.onSuccess();
    }

    render(): JSX.Element {
        const { credits, payment } = this.state;
        const { onProcessing, onError } = this.props;

        return (
            <>
                {!payment ? (
                    <div className="set-price-modal">
                        <h2>Add credits</h2>
                        <p>How many credits would you like to add?</p>
                        <div className="price-input-container">
                            <Input
                                value={credits}
                                onChange={(credits: string) => this.handleCreditsChange(credits)}
                                extraValidation={(e) => ({
                                    valid: !isNaN(Number(e)) && Number(e) >= 0,
                                    defaultMessage: "Not a valid number",
                                })}
                            />
                            <p className="price-suffix">credits</p>
                        </div>
                        <div className="set-price-wrapper">
                            <Button
                                disabled={isNaN(Number(credits)) || Number(credits) < 0 || credits === ""}
                                onClick={() => this.showPayment() /*onSetPrice(price)*/}
                            >
                                Choose a payment method
                            </Button>
                        </div>
                    </div>
                ) : (
                    <PaymentComponent
                        price={credits}
                        title="Add credits"
                        back
                        onBack={() => this.goBack()}
                        successMessage="Credits added successfuly"
                        onCompleted={() => this.onCompleted()}
                        onError={() => (onError ? onError() : undefined)}
                        onProcessing={() => (onProcessing ? onProcessing() : undefined)}
                    />
                )}
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/account/parts/add-credits-component.tsx